<template>
    <div class="sa-timeline" :style="{ maxHeight: maxHeight + 'px', overflowY: 'auto' }">
        <div v-if="!items || items.length === 0" class="sa-timeline-empty">
            Nessun appuntamento presente
        </div>

        <div v-for="(item, index) in items" :key="index" class="sa-timeline-item">
            <div class="sa-timeline-indicator">
                <div class="sa-timeline-dot"></div>
                <div v-if="index !== items.length - 1" class="sa-timeline-line"></div>
            </div>

            <div class="sa-timeline-content">
                <span class="sa-timeline-date">{{ item.data }}</span>
                <div class="sa-timeline-card">
                    <span class="sa-timeline-title">{{ item.prestazione }}</span>
                    <span class="sa-timeline-subtitle">{{ item.medico }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: { type: Array, default: () => [] },
        maxHeight: { type: [String, Number], default: 300 }
    }
}
</script>

<style scoped>
.sa-timeline {
    padding: 0 5px 10px 5px;
    /* Zero padding in alto */
}

.sa-timeline-item {
    display: flex;
    gap: 12px;
    margin-bottom: 0;
}

.sa-timeline-indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 12px;
    flex-shrink: 0;
}

.sa-timeline-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #1e6f65;
    border: 2px solid #e7f4f2;
    z-index: 2;
    margin-top: 3px;
    /* Allineamento millimetrico alla prima riga di testo */
}

.sa-timeline-line {
    width: 2px;
    flex-grow: 1;
    background-color: #e4f1ef;
    margin: 2px 0;
}

.sa-timeline-content {
    flex-grow: 1;
    padding-bottom: 15px;
    /* Spazio tra un appuntamento e l'altro */
}

.sa-timeline-date {
    font-size: 10px;
    font-weight: 700;
    color: #6b8f8b;
    display: block;
    margin-bottom: 4px;
    text-transform: uppercase;
    line-height: 1;
}

.sa-timeline-card {
    background: #f9fcfc;
    border: 1px solid #e4f1ef;
    border-radius: 8px;
    padding: 8px 12px;
}

.sa-timeline-title {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #243c3a;
}

.sa-timeline-subtitle {
    display: block;
    font-size: 11px;
    color: #6b8f8b;
}

.sa-timeline-empty {
    font-size: 12px;
    color: #999;
    text-align: center;
    padding: 20px;
}
</style>